import { FAILURE, LOADING, NAMESPACE, NOT_ASKED, ATLAS_REQUEST } from './constants';
import reducer from './reducer';
import sagas from './sagas';
import { atlasRequest, loading, failure, success, notAsked } from './actions';
import { selectStatus, selectTransferId, selectResults, selectError } from './selectors';

export {
  atlasRequest,
  ATLAS_REQUEST,
  loading,
  failure,
  notAsked,
  success,
  reducer,
  sagas,
  FAILURE,
  LOADING,
  NAMESPACE,
  NOT_ASKED,
  selectStatus,
  selectTransferId,
  selectResults,
  selectError,
};



// WEBPACK FOOTER //
// ./src/services/atlasRequest/index.js